import { SubjectRule } from "@shared/lib/casl/types.ts";

export const dedupeAbilities = (abilities: SubjectRule[]) => {
  const set = new Set();
  return abilities.filter((a) => {
    const key = `${a.subject}-${a.action}`;
    return !set.has(key) && set.add(key);
  });
};
